import * as React from "react";
import { Loader } from "lucide-react";
import { useSendResetPasswordEmail } from "@/hooks/useSendResetPasswordEmail";
const Login = React.lazy(() => import("./Login"));
const EmailSent = React.lazy(() => import("./EmailSent"));
const ForgotPasswordEmail = React.lazy(() => import("./ForgotPasswordEmail"));

const AuthFlow: React.FC = () => {
  const [showForgotPassword, setShowForgotPassword] = React.useState(false);
  const [showEmailSent, setShowEmailSent] = React.useState(false);
  const [resetEmail, setResetEmail] = React.useState("");

  const sendResetEmailMutation = useSendResetPasswordEmail();

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setShowEmailSent(false);
    setResetEmail("");
  };

  const handleEmailSent = (email: string) => {
    setResetEmail(email);
    setShowForgotPassword(false);
    setShowEmailSent(true);
  };

  const handleShowForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const handleResendLink = () => {
    sendResetEmailMutation.mutate({ email: resetEmail });
  };

  return (
    <React.Suspense
      fallback={
        <div className="flex flex-col items-center justify-center h-full gap-4">
          <Loader className="animate-spin" size={48} />
          <p>Loading...</p>
        </div>
      }
    >
      {showEmailSent ? (
        <EmailSent
          onBackToLogin={handleBackToLogin}
          onResendLink={handleResendLink}
          isResending={sendResetEmailMutation.isPending}
          email={resetEmail}
        />
      ) : showForgotPassword ? (
        <ForgotPasswordEmail onBackToLogin={handleBackToLogin} onEmailSent={handleEmailSent} />
      ) : (
        <Login onShowForgotPassword={handleShowForgotPassword} />
      )}
    </React.Suspense>
  );
};

export default AuthFlow;
